/**
 * Header Dropdown Menu Image Hover Controller
 * Manages the display of collection images based on menu item hover
 */
class HeaderDropdownMenu {
  constructor() {
    this.initializeHoverHandlers();
  }

  initializeHoverHandlers() {
    // Get all menu items with collection handles
    const menuItems = document.querySelectorAll('.menu-item-trigger[data-collection-handle]');
    
    menuItems.forEach((menuItem, index) => {
      const collectionHandle = menuItem.getAttribute('data-collection-handle');
      
      // Add hover event listeners
      menuItem.addEventListener('mouseenter', () => {
        this.showImage(collectionHandle);
      });
    });

    // Reset to first image when menu is closed
    const menuDetails = document.querySelectorAll('details[id^="Details-HeaderMenu-"]');
    menuDetails.forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) {
          this.resetToFirstImageInMenu(detail);
        }
      });
    });
  }

  showImage(collectionHandle) {
    // Find the current submenu context by looking for the closest parent submenu
    const hoveredMenuItem = document.querySelector(`.menu-item-trigger[data-collection-handle="${collectionHandle}"]`);
    if (!hoveredMenuItem) return;

    const activeSubmenu = hoveredMenuItem.closest('.header__submenu-wrapper');
    if (!activeSubmenu) return;

    // Remove active class from all images in this submenu
    const allImages = activeSubmenu.querySelectorAll('.header__submenu-image');
    allImages.forEach(image => image.classList.remove('active'));

    // Add active class to the matching image
    const targetImage = activeSubmenu.querySelector(`.header__submenu-image[data-collection-handle="${collectionHandle}"]`);
    if (targetImage) {
      targetImage.classList.add('active');
    }

    // Remove active class from all content items in this submenu
    const allContentItems = activeSubmenu.querySelectorAll('.header__submenu-content-item');
    allContentItems.forEach(item => item.classList.remove('active'));

    // Add active class to the matching content item
    const targetContent = activeSubmenu.querySelector(`.header__submenu-content-item[data-collection-handle="${collectionHandle}"]`);
    if (targetContent) {
      targetContent.classList.add('active');
    }
  }

  resetToFirstImageInMenu(detail) {
    const submenu = detail.querySelector('.header__submenu-wrapper');
    if (!submenu) return;

    // Remove active from all images
    const allImages = submenu.querySelectorAll('.header__submenu-image');
    allImages.forEach(image => image.classList.remove('active'));

    // Add active to first image
    const firstImage = submenu.querySelector('.header__submenu-image');
    if (firstImage) {
      firstImage.classList.add('active');
    }

    // Remove active from all content items
    const allContentItems = submenu.querySelectorAll('.header__submenu-content-item');
    allContentItems.forEach(item => item.classList.remove('active'));

    // Add active to first content item
    const firstContentItem = submenu.querySelector('.header__submenu-content-item');
    if (firstContentItem) {
      firstContentItem.classList.add('active');
    }
  }

  resetToFirstImage(submenu) {
    // Remove active from all images
    const allImages = submenu.querySelectorAll('.header__submenu-image');
    allImages.forEach(image => image.classList.remove('active'));

    // Add active to first image
    const firstImage = submenu.querySelector('.header__submenu-image');
    if (firstImage) {
      firstImage.classList.add('active');
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new HeaderDropdownMenu();
});

// Also initialize if the script is loaded after DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeaderDropdownMenu();
  });
} else {
  new HeaderDropdownMenu();
}
